import ForgotPassword from './components/ForgotPassword';

export default (store) => ({
    path: 'forgot-password',
    component: ForgotPassword,
});



// WEBPACK FOOTER //
// ./src/routes/user/routes/ForgotPassword/index.js